module.exports = {
  bindings: {
    document: '@',
  },
  controller: class PatientLegalController {

    static $inject = [
      '$translate',
    ];

    constructor($translate) {
      this.$translate = $translate;
    }

    $onInit() {
      this.locale = this.$translate.use();
    }
  },
  template: `
    <div class="terms">
      <section class="container">
        <div class="wrapper">
          <span ng-include src="'main/templates/legal/' + $ctrl.locale + '/' + $ctrl.document + '.html'"></span>
        </div>
      </section>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./main/components/patient-legal.js